export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/combination-tourist.53c30500-2621d3.png";